import React, { useState } from 'react'
import {
  required,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useTranslate,
  BooleanInput,
  Edit,
  useEditController
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { companyServices } from 'src/services/payment/company/company.service'
import { gatewayServices } from 'src/services/payment/gateway/gateway.service'
import { cardServices } from 'src/services/payment/card/card.service'

export const CommerceNumberEdit = (props, { id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [workUnitsLoading, setWorkUnitsLoading] = useState(false)
  const [workUnits, setWorkUnits] = useState([])
  const [companyLoading, setCompanyLoading] = useState(false)
  const [company, setCompany] = useState([])
  const [cardLoading, setCardLoading] = useState(false)
  const [card, setCard] = useState([])
  const [gatewayLoading, setGatewayLoading] = useState(false)
  const [gateway, setGateway] = useState([])
  const { record, isLoading, isFetching } = useEditController({ resource: 'commerce-number', id })

  const onSuccess = () => {
    notify('ra.notification.updated_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.entity.commerce-number') },
    })
    redirect('/commerce-number')
  }

  const onError = () => {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.entity.commerce-number') },
    })
  }

  let searchTimeoutcomapny
  const getCompany = async (user, length = 2) => {
    clearTimeout(searchTimeoutcomapny)

    if (
      (!user?.short_name || user.short_name.length < length) &&
      (!user?.long_name || user.long_name.length < length)
    ) {
      setCompany([])
      return
    }

    searchTimeoutcomapny = setTimeout(async () => {
      try {
        setCompanyLoading(true)
        const filter = {
          short_name: user?.short_name,
        }
        if (user?.long_name) {
          filter.long_name = user?.long_name
        }
        const work_unit = await companyServices.getByAll(filter)
        setCompany(work_unit)
      } catch (error) {
        setCompany([])
      } finally {
        setCompanyLoading(false)
      }
    }, 1000)
  }

  let searchTimeoutworkUnit
  const getWorkUnit = async (user, length = 2) => {
    clearTimeout(searchTimeoutworkUnit)

    if (
      (!user?.short_name || user.short_name.length < length) &&
      (!user?.long_name || user.long_name.length < length)
    ) {
      setWorkUnits([])
      return
    }

    searchTimeoutworkUnit = setTimeout(async () => {
      try {
        setWorkUnitsLoading(true)
        const filter = {
          short_name: user?.short_name,
        }
        if (user?.long_name) {
          filter.long_name = user?.long_name
        }
        const work_unit = await workUnitServices.getByAll(filter)
        setWorkUnits(work_unit)
      } catch (error) {
        setWorkUnits([])
      } finally {
        setWorkUnitsLoading(false)
      }
    }, 1000)
  }

  let searchTimeoutcard
  const getCard = async (user, length = 2) => {
    clearTimeout(searchTimeoutcard)

    if (
      (!user?.short_name || user.short_name.length < length) &&
      (!user?.long_name || user.long_name.length < length)
    ) {
      setCard([])
      return
    }

    searchTimeoutcard = setTimeout(async () => {
      try {
        setCardLoading(true)
        const filter = {
          short_name: user?.short_name,
        }
        if (user?.long_name) {
          filter.long_name = user?.long_name
        }
        const work_unit = await cardServices.getByAll(filter)
        setCard(work_unit)
      } catch (error) {
        setCard([])
      } finally {
        setCardLoading(false)
      }
    }, 1000)
  }

  let searchTimeoutgateway
  const getGateway = async (user, length = 2) => {
    clearTimeout(searchTimeoutgateway)

    if (!user?.name || user.name.length < length) {
      setGateway([])
      return
    }

    searchTimeoutgateway = setTimeout(async () => {
      try {
        setGatewayLoading(true)
        const filter = {
          name: user?.name,
        }
        const gateway = await gatewayServices.getByAll(filter)
        setGateway(gateway)
      } catch (error) {
        setGateway([])
      } finally {
        setGatewayLoading(false)
      }
    }, 1000)
  }

  const transform = (record) => {
    let data = { ...record }
    if (!Number.isInteger(record?.card_id)) {
      data.card_id = data?.card_id?.id
    }
    if (!Number.isInteger(record?.company_id)) {
      data.company_id = data?.company_id?.id
    }
    if (!Number.isInteger(record?.gateway_id)) {
      data.gateway_id = data?.gateway_id?.id
    }
    if (record?.work_unit_relation) {
      data.work_unit = {
        hash_work_unit: record?.work_unit_relation?.hash_work_unit,
        token: record?.work_unit_relation?.token,
      }
      delete data?.work_unit_relation
    }
    return data
  }


  const manageOptions = (options, defaulOption) => {
    try {
      const existDefaultOption = options.some((option) => option?.id === defaulOption?.id)
      if (existDefaultOption) {
        return options
      }
      return [defaulOption, ...options]
    } catch (error) {
      return [defaulOption, ...options]
    }
  }
  console.log('{ ...record?.work_unit_relation, id: record?.work_unit_id }', {
    ...record?.work_unit_relation,
    id: record?.work_unit_id,
  })
  

  return (
    <Edit
      {...props}
      mutationMode='pessimistic'
      mutationOptions={{ onSuccess, onError }}
      actions={null}
      transform={transform}
    >
      <CardCommon title={translate('ra.title.update_commerce_number')}>
        <SimpleForm
          toolbar={
            <CardCrudBottomButtons
              btnSave={true}
              btnDelete={true}
              fieldsName={['short_name']}
              genderElement='masculine'
            />
          }
        >
          <Grid container spacing={3}>
            <EditInputsWrap
              label={translate('ra.field.work_unit')}
              tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
              md={4}
              required
              style={{ margin: '0 0 20px 0' }}
            >
              {isLoading || isFetching ? (
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} sx={{ padding: '0px 3px !important', margin: '0 !important' }}>
                    <Skeleton width='100%' height='53px' />
                  </Grid>
                  <Grid item xs={12} sm={6} sx={{ padding: '0px 3px !important', margin: '0 !important' }}>
                    <Skeleton width='100%' height='53px' />
                  </Grid>
                  <Grid item xs={12} sx={{ padding: '0 !important', margin: '0 !important' }}>
                    <Skeleton width='100%' height='53px' />
                  </Grid>
                </Grid>
              ) : (
                <MultiAutocompleteInput
                  source={'work_unit_id'}
                  options={[{ ...record?.work_unit_relation, id: record?.work_unit_id }, ...workUnits]}
                  loading={workUnitsLoading}
                  optionsText={['short_name', 'long_name']}
                  separator=' | '
                  optionValue='id'
                  onSearch={getWorkUnit}
                  resetOnLoad={false}
                  fields={['short_name', 'long_name']}
                  validate={[required()]}
                  showAllOptionText
                  useOptionValue
                  equalToValueByOptionValue
                  disableClearable
                  disablePortal
                />
              )}
            </EditInputsWrap>

            <EditInputsWrap
              label={translate('ra.field.company')}
              md={4}
              required
              style={{ margin: '0 0 20px 0' }}
            >
              <MultiAutocompleteInput
                source={'company_id'}
                options={manageOptions(company, record?.company_relation)}
                loading={companyLoading}
                validate={[required()]}
                optionsText={['short_name', 'long_name']}
                separator=' | '
                optionValue='id'
                onSearch={getCompany}
                resetOnLoad={false}
                fields={['short_name', 'long_name']}
                showAllOptionText
                useOptionValue
                equalToValueByOptionValue
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={translate('ra.field.card')}
              tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
              md={4}
              required
              style={{ margin: '0 0 20px 0' }}
            >
              <MultiAutocompleteInput
                source={'card_id'}
                options={[record?.card_relation, ...card]}
                loading={cardLoading}
                validate={[required()]}
                optionsText={['short_name', 'long_name']}
                separator=' | '
                optionValue='id'
                onSearch={getCard}
                resetOnLoad={false}
                fields={['short_name', 'long_name']}
                showAllOptionText
                useOptionValue
                equalToValueByOptionValue
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={translate('ra.field.gateway')}
              tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
              md={4}
              required
              style={{ margin: '0 0 20px 0' }}
            >
              <MultiAutocompleteInput
                source={'gateway_id'}
                options={[record?.gateway_relation, ...gateway]}
                loading={gatewayLoading}
                validate={[required()]}
                optionsText={['name']}
                separator=' | '
                optionValue='id'
                onSearch={getGateway}
                resetOnLoad={false}
                fields={['name']}
                showAllOptionText
                useOptionValue
                equalToValueByOptionValue
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.commerce_number')} required>
              <TextInput source='value' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.terminal')} required>
              <TextInput source='terminal' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.state')}>
              <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
